import { LoginModal } from '@common/LoginModal.js';

document.addEventListener('DOMContentLoaded', () => {
    const auth = new LoginModal('login-app');
    auth.show();
});
